import { initCurrentLocationSearch } from '@common/utils/currentLocationSearch'

// ab_test.ts が DOMContentLoaded で dispatch する `ab-test-initialized:...` イベントを
// 取りこぼさないよう、 entrypoint 読込時に同期で listener を登録する
initCurrentLocationSearch()
